import type { JSX, ComponentProps } from "react";

import { type ColumnDefinition, ChartTooltip } from "@similarweb/ui-components";

type ChartTooltipProps<DataRecord> = ComponentProps<typeof ChartTooltip<DataRecord>>;

export type ChartTooltipColumnDefinition<DataRecord> = {
    [K in keyof DataRecord]: {
        key: string;
        title: string;
        align: "left" | "right";
        borderRight?: boolean;
        selector: K;
        size: string;
        render: (data: { [key in K]: DataRecord[K] }) => JSX.Element;
    };
}[keyof DataRecord];

type ChartTooltipWrapperProps<DataRecord> = {
    columnDefinition: Array<ChartTooltipColumnDefinition<DataRecord>>;
    data: DataRecord[];
    withoutColumnTitles?: boolean;
} & Omit<ChartTooltipProps<DataRecord>, "columnDefinition" | "data" | "withoutColumnTitles">;

export const ChartTooltipWrapper = <DataRecord,>({
    columnDefinition,
    data,
    children,
    withoutColumnTitles,
    ...rest
}: ChartTooltipWrapperProps<DataRecord>): JSX.Element => {
    return (
        <ChartTooltip<DataRecord>
            {...rest}
            columnDefinition={columnDefinition as ColumnDefinition<DataRecord>[]}
            data={data}
            withoutColumnTitles={withoutColumnTitles}
        >
            {children}
        </ChartTooltip>
    );
};
